import { createApp } from 'vue';
import App from './App';
import '@unocss/reset/tailwind.css';
import 'virtual:uno.css';
import './fonts/quicksand/Quicksand.400.css';
import './fonts/quicksand/Quicksand.500.css';
import '@fontsource/noto-sans-sc/400.css';
import './global.sass';

createApp(App)
  .mount('#app');
